/**
 * @generated SignedSource<<26db6503377cdd374065c119739efc50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildSocialProfileLinks_guild$data = {
  readonly blueskyIdentifier: string | null | undefined;
  readonly blueskyUrl: string | null | undefined;
  readonly githubUrl: string | null | undefined;
  readonly instagramUrl: string | null | undefined;
  readonly linkedinUrl: string | null | undefined;
  readonly twitterUrl: string | null | undefined;
  readonly websiteUrl: string | null | undefined;
  readonly youtubeUrl: string | null | undefined;
  readonly " $fragmentType": "GuildSocialProfileLinks_guild";
};
export type GuildSocialProfileLinks_guild$key = {
  readonly " $data"?: GuildSocialProfileLinks_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildSocialProfileLinks_guild">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildSocialProfileLinks_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "websiteUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "twitterUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instagramUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkedinUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "youtubeUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "githubUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blueskyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blueskyIdentifier",
      "storageKey": null
    }
  ],
  "type": "Guild",
  "abstractKey": null
};

(node as any).hash = "c6d2be6ed244fa8db5e1520715f40c2e";

export default node;
